import React from 'react';
import { Loader2 } from 'lucide-react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'ghost' | 'gold';
  size?: 'sm' | 'md' | 'lg';
  isLoading?: boolean;
  href?: string;
  target?: string;
  rel?: string;
}
export function Button({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  isLoading = false,
  disabled,
  href,
  target,
  rel,
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center rounded-full font-bold transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none uppercase tracking-wide';
  const variants = {
    primary: 'bg-brand-primary text-white hover:bg-rose-700 shadow-lg hover:shadow-rose-500/30 focus:ring-rose-500',
    secondary: 'bg-brand-dark text-white hover:bg-gray-900 shadow-md hover:shadow-lg focus:ring-gray-900',
    outline: 'border-2 border-brand-primary bg-transparent hover:bg-brand-soft text-brand-primary focus:ring-brand-primary',
    ghost: 'bg-transparent hover:bg-brand-soft text-brand-primary hover:text-brand-dark',
    gold: 'bg-brand-gold text-white hover:bg-yellow-600 shadow-lg hover:shadow-xl focus:ring-yellow-500'
  };
  const sizes = {
    sm: 'h-9 px-4 text-xs',
    md: 'h-11 px-6 text-sm',
    lg: 'h-14 px-8 text-base md:text-lg'
  };
  const combinedClass = `${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`;
  if (href) {
    return <a href={href} target={target} rel={rel} className={combinedClass} data-id="element-277">
        {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-278" />}
        {children}
      </a>;
  }
  return <button className={combinedClass} disabled={disabled || isLoading} {...props} data-id="element-279">
      {isLoading && <Loader2 className="mr-2 h-4 w-4 animate-spin" data-id="element-280" />}
      {children}
    </button>;
}